import { render, staticRenderFns } from "./ShippingRecipientInfo.vue?vue&type=template&id=7f647093&"
import script from "./ShippingRecipientInfo.vue?vue&type=script&lang=js&"
export * from "./ShippingRecipientInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports